import {Maybe} from '../generated/graphql';

interface Project {
  access: Maybe<string>;
}

export function isPublicRead(p: Project): boolean {
  if (p.access == null) {
    return false;
  }

  return ['USER_READ', 'USER_WRITE'].indexOf(p.access) !== -1;
}
